import React, { forwardRef } from 'react';
import { InputAmountContainer, InputAmountLabel, InputAmountMessageError } from './styles';
import IntlCurrencyInput from "react-intl-currency-input";

const InputAmount = forwardRef(({ id, label, error, name, setValue, currencyConfig, register, defaultValue, disabled, ...rest }, ref) => {
  return (
    <InputAmountContainer id="input-amount">
      <InputAmountLabel htmlFor={id}>{label}</InputAmountLabel>
      <IntlCurrencyInput 
        currency={currencyConfig.currency} 
        config={currencyConfig} 
        onChange={(event, value, maskedValue) => setValue(name, value)} 
        className={error && 'error'} 
        value={parseInt(defaultValue)} 
        disabled={disabled}
        {...rest} />
      <input type="hidden" name={name} ref={register} id={id} disabled={disabled} />
      {error && <InputAmountMessageError error={error}>{error.message}</InputAmountMessageError>}
    </InputAmountContainer>
  )
})

export default InputAmount
